import { render, staticRenderFns } from "./LevyCalculationPanelTotals.vue?vue&type=template&id=8745cd8e&"
import script from "./LevyCalculationPanelTotals.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports